module.exports = __webpack_public_path__ + "static/media/FlockFinal.c44f2822.svg";